/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'ai-mate.chat-error-banner.description': "Votre historique de chat est conservé jusqu'à 30 jours.",
  'ai-mate.chat-error-banner.title': 'Démarrer un nouveau chat',
  'ai-mate.chat-error.description': 'Essayez de <btn>recharger le chat</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Vous avez atteint le nombre maximal de demandes. Veuillez réessayer ultérieurement.',
  'ai-mate.chat-error.rate-limited-title': 'Trop de demandes',
  'ai-mate.chat-error.rovo-inactive-description':
    "Il semble que Rovo n'est pas activé sur votre site. <link>Configurer Rovo</link>",
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo est inactif',
  'ai-mate.chat-error.title': "Nous ne savons pas ce qui s'est passé",
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Chat Rovo',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Interroger Atlassian Intelligence à ce sujet',
  'highlight-actions.rovo-chat-explain-option.text': 'Expliquer',
  'highlight-actions.rovo-chat-explain-prompt': 'Expliquer ce contenu : {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Recommandations de Rovo Chat',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Ouvrir Rovo Chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Résumer',
  'highlight-actions.rovo-chat-summarize-prompt': 'Résumer ce contenu : {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'Conversation instantanée',
  'horizontal-scroll-container.scroll-left': 'Faire défiler vers la gauche',
  'horizontal-scroll-container.scroll-right': 'Faire défiler vers la droite',
};
